package com.vamvisions.main.components

import androidx.compose.runtime.Composable
import com.vamvisions.main.core.presentation.navigation.Route
import com.vamvisions.main.navigation.AppLink
import com.vamvisions.main.navigation.ExternalLink
import com.vamvisions.main.theme.AppStyleSheet
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLAnchorElement

/** A link styled as a button that opens a page of this website in place. A [primary] one is the filled main action. */
@Composable
fun LinkButton(label: String, route: Route, onNavigate: (Route) -> Unit, primary: Boolean = false) {
    AppLink(route, onNavigate, attrs = { linkButtonClasses(primary) }) {
        LinkButtonContent(label, primary)
    }
}

/** A link styled as a button that opens another site in a new tab. A [primary] one is the filled main action. */
@Composable
fun LinkButton(label: String, href: String, primary: Boolean = false) {
    ExternalLink(href, attrs = { linkButtonClasses(primary) }) {
        LinkButtonContent(label, primary)
    }
}

private fun AttrsScope<HTMLAnchorElement>.linkButtonClasses(primary: Boolean) {
    classes(AppStyleSheet.linkButton)
    if (primary) classes(AppStyleSheet.linkButtonPrimary)
}

/** A primary button ends with an arrow, hidden from assistive technology. */
@Composable
private fun LinkButtonContent(label: String, primary: Boolean) {
    Text(label)
    if (primary) Span(attrs = { attr("aria-hidden", "true") }) { Text("→") }
}
